// @ts-nocheck
import { chain, SetUserFields } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SetUserFields";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

interface BunzlProperties extends Record<string, string> {
    reportingRoles: string;
    bunzl_AdditionalApprovers: string;
    languageId: string;
    canSeePricesPolicy: string;
}

interface ParameterWithBunzlProperties
    extends Readonly<{
        email?: string;
        firstName?: string;
        lastName?: string;
        role?: string;
        approver?: string;
        isApproved?: boolean;
    }> {
    properties?: BunzlProperties;
}

replaceInChain(chain, SetUserFields, props => {
    const { parameter = {} as ParameterWithBunzlProperties, result } = props;
    if (!result.updatedUser) {
        throw new Error("There was no editingUser set and we are trying to update it.");
    }
    result.updatedUser.email = parameter.email ?? result.updatedUser.email;
    result.updatedUser.firstName = parameter.firstName ?? result.updatedUser.firstName;
    result.updatedUser.lastName = parameter.lastName ?? result.updatedUser.lastName;
    result.updatedUser.role = parameter.role ?? result.updatedUser.role;
    result.updatedUser.approver = parameter.approver ?? result.updatedUser.approver;
    result.updatedUser.isApproved = parameter.isApproved ?? result.updatedUser.isApproved;

    const typedParameter = parameter as ParameterWithBunzlProperties;
    const currentProperties = result.updatedUser.properties || {};

    const updateProperty = (key: keyof BunzlProperties, defaultValue: string | undefined): string =>
        typedParameter.properties?.[key] ?? defaultValue ?? "";

    const updatedProperties: BunzlProperties = {
        ...currentProperties,
        canSeePricesPolicy: updateProperty("canSeePricesPolicy", currentProperties.canSeePricePolicy),
        reportingRoles: updateProperty("reportingRoles", currentProperties.reportingRoles),
        bunzl_AdditionalApprovers: updateProperty(
            "bunzl_AdditionalApprovers",
            currentProperties.bunzl_AdditionalApprovers,
        ),
        languageId: updateProperty("languageId", currentProperties.languageId),
    };

    result.updatedUser.properties = updatedProperties;
});
